module.exports = __webpack_public_path__ + "static/media/sccview_icon.ea25fdea.ico";